// This file is kept as a thin wrapper so existing imports continue to work.
// It simply re-exports the new Ant Design based modal implementation.

import ApplyForAuthorisationModal from "./ApplyForAuthorisationModal.jsx";

export default ApplyForAuthorisationModal;

